import ManageEventPrompt from "./ManageEventPrompt";
export default ManageEventPrompt;
